import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { DateValidator } from '../validators/date.validator';
import * as dayjs from 'dayjs';
/*
 This is a clone MaxDateValidator with input value change and revalidation support
*/
@Directive({
  standalone: false,
  selector: '[iesResponsiveMaxDate]',
  providers: [
    {
      provide: NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: ResponsiveMaxDateValidator,
      multi: true,
    },
  ],
})
export class ResponsiveMaxDateValidator implements Validator {
  private _onChange?: () => void;
  private _maxTime;
  private _message;

  @Input('iesResponsiveMaxDateStrFormate') dateFormat = 'YYYYMM';

  @Input('iesResponsiveMaxDate')
  get maxDateValue() {
    return this._maxTime;
  }

  set maxDateValue(value) {
    this._maxTime = value;
    if (this._onChange) {
      this._onChange();
    }
  }
  @Input('iesMaxDateErrorMessage') get message() {
    return this._message;
  }

  set message(value) {
    this._message = value;
    if (this._onChange) {
      this._onChange();
    }
  }

  validate(control: AbstractControl) {
    if (typeof control.value === 'string') {
      return DateValidator.maxDateStr(this.maxDateValue, this.dateFormat, '', this.message)(control);
    } else {
      return DateValidator.maxDate(this.maxDateValue, '', this.message)(control);
    }
  }

  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }
}
